import { ClusterApi, ClusterContentApi } from "@cluster/web-components";
import { Token } from "client-oauth2";
import rbnOAuth from './oauth';

if (typeof process.env.REACT_APP_API_HOST == "undefined"
  || typeof process.env.REACT_APP_API_PREFIX == "undefined"
  || typeof process.env.REACT_APP_CLUSTER_WEB_HOST == "undefined") {
    throw Error("API variables not found.");
}

type AllowedTokenProps = 'accessToken' | 'refreshToken' | 'data' | 'tokenType';
type DissallowedTokenProps = {
  [P in keyof Omit<Token, AllowedTokenProps>]?: never;
}

export type AuthTokenData = Pick<Token, AllowedTokenProps> & DissallowedTokenProps;

const api = {...ClusterApi,
  ...ClusterContentApi,
  // Save the Cluster token into the api settings
  setToken: function(token: string) {
    // Set the token in the api.
    this.defaults.headers = {
      'Authorization': 'Bearer ' + token
    }
  },
  // Get new Cluster API Token
  getNewToken: async function(authToken?: string) {
    let data: ClusterApi.AuthResponse;

    // Authenticate with RBN if an auth token is passed. Otherwise authenticate as guest.
    if (authToken) {
      data = await this.auth({accessToken: authToken}).catch(error => { throw error.message });
    } else {
      data = await this.authGuest().catch(error => { throw error.message });
    }

    // Set the token in the api.
    this.setToken(data.token);

    return data;
  },
  // authSourceToken: undefined as Token | undefined,
  getAuthSourceCodeRedirect: function(oauthNonce: string) {
    return rbnOAuth.code.getUri({state: oauthNonce})
  },
  requestAuthSourceToken: async function(uri: string, oauthNonce: string) {
    return rbnOAuth.code.getToken(uri, {state: oauthNonce})
  },
  refreshAuthSourceToken: function(authTokenData: AuthTokenData) {
    try {
      const token = rbnOAuth.createToken(authTokenData?.accessToken, authTokenData?.refreshToken, authTokenData?.tokenType, authTokenData?.data);

      return token.refresh();
    } catch (message) {
      return Promise.reject(message);
    }
  },
};

api.defaults.baseUrl = process.env.REACT_APP_API_HOST + process.env.REACT_APP_API_PREFIX;
api.contentDefaults.baseUrl = process.env.REACT_APP_CLUSTER_WEB_HOST;

export default api;
